import { MarkdownPanelSpec } from '@/core';

export function createInitialMarkdownPanelSpec(): MarkdownPanelSpec {
  return { text: '' };
}
